import { SpecialRequestFormField } from '../../../../types/enums'
import { IElementProps } from '../../../../types/interfaces'
import Input from '../Input'
import TextArea from '../TextArea'
import AddressSearch from '../addressSearch'
import BrandsSelect from '../brandsSelect'
import CantonsSelect from '../cantonsSelect'
import CheckBox from '../checkBox'
import ColorSelect from '../colorSelect'
import CustomersSelect from '../customersSelect'
import CustomersSelectUnlinked from '../customersSelectUnlinked'
import DatePick from '../datePicker'
import FuelSelect from '../fuelSelect'
import GeneratedImage from '../generatedImage'
import GenericDropDown from '../genericDropDown'
import GenericRadio from '../genericRadio'
import HyperLink from '../hyperLink'
import Radio from '../radio'
import SearchInput from '../searchInput'
import Select from '../select'
import Separator from '../separator'
import TextLabel from '../textLabel'
import UnitsSelect from '../unitsSelect'
import UnitsSelectUnlinked from '../unitsSelectUnlinked'
import Upload from '../upload'
import ZipSearch from '../zipSearch'

const Element = (props: { field: IElementProps }) => {
  let el = null
  const reservedFieldTypes: string[] = [
    SpecialRequestFormField.CustomersSelect,
    SpecialRequestFormField.CustomersSelectUnlinked,
    SpecialRequestFormField.UnitsSelect,
    SpecialRequestFormField.UnitsSelectUnlinked,
    SpecialRequestFormField.FuelSelect,
  ]
  const externalDataKey = reservedFieldTypes.includes(props.field.type)
    ? props.field.type
    : props.field.externalDataSourceName
  const externalData = externalDataKey ? props.field.externalDataDict[externalDataKey] : undefined
  const newOptions =
    props.field.options && props.field.options.length
      ? props.field.options.map((o) => ({
          ...o,
          name: o.tr && o.tr[props.field.lang] ? o.tr[props.field.lang] : o.name,
        }))
      : props.field.options
  const newProps: IElementProps = { ...props.field, externalData, options: newOptions }
  switch (props.field.type) {
    case 'genericRadio':
      el = <GenericRadio {...newProps} />
      break
    case 'genericSelect':
      el = <GenericDropDown {...newProps} />
      break
    case 'generatedimage':
      el = <GeneratedImage {...newProps} />
      break
    case 'textWithSearch':
      el = <SearchInput {...newProps} />
      break
    case 'text':
      el = <Input {...newProps} />
      break
    case 'zipSelect':
      el = <ZipSearch {...newProps} />
      break
    case 'textarea':
      el = <TextArea {...newProps} />
      break
    case 'fuelSelect':
      el = <FuelSelect {...newProps} />
      break
    case 'datePick':
      el = <DatePick {...newProps} />
      break
    case 'radio':
      el = <Radio {...newProps} />
      break
    case 'cantonSelect':
      el = <CantonsSelect {...newProps} />
      break
    case 'brandSelect':
      el = <BrandsSelect {...newProps} />
      break
    case 'colorSelect':
      el = <ColorSelect {...newProps} />
      break
    case 'checkBox':
      el = <CheckBox {...newProps} />
      break
    case 'select':
      el = <Select {...newProps} />
      break
    case 'customersSelect':
      el = <CustomersSelect {...newProps} />
      break
    case 'unitsSelect':
      el = <UnitsSelect {...newProps} />
      break
    case 'customersSelectUnlinked':
      el = <CustomersSelectUnlinked {...newProps} />
      break
    case 'unitsSelectUnlinked':
      el = <UnitsSelectUnlinked {...newProps} />
      break
    case 'upload':
      el = <Upload {...newProps} />
      break
    case 'label':
      el = <TextLabel {...newProps} />
      break
    case 'link':
      el = <HyperLink {...newProps} />
      break
    case 'addressSearch':
      el = <AddressSearch {...newProps} />
      break
    case 'separator':
      el = <Separator {...newProps} />
      break
    default:
      break
  }

  const validationErrors = props.field.validationErrors[props.field.name]

  return (
    <div
      className={`form-element ${props.field.section === props.field.currentSection ? 'active' : 'notActive'} ${
        props.field.required ? 'required' : 'optional'
      } ${
        (props.field.submitFired && props.field.required && !props.field.value) ||
        (props.field.submitFired && validationErrors?.length) ||
        (props.field.submitFired &&
          props.field.required &&
          props.field.type === 'checkBox' &&
          props.field.value === 'false')
          ? 'required-field-empty'
          : ''
      }${
        (props.field.required && props.field.value && props.field.type !== 'checkBox') ||
        (props.field.required && props.field.type === 'checkBox' && props.field.value === 'true')
          ? 'required-field-filled'
          : ''
      }`}
    >
      {el}
      {props.field.type === 'HTMLText' ? null : <p />}
      {/* <p /> */}
    </div>
  )
}
export default Element
